import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M12.6 8a.6.6 0 1 0-1.2 0v5a.6.6 0 1 0 1.2 0V8Zm-1.45 8c0-.47.38-.85.85-.85h.01a.85.85 0 0 1 0 1.7H12a.85.85 0 0 1-.85-.85Z"
    />
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Zm8.8-10a8.8 8.8 0 1 1-17.6 0 8.8 8.8 0 0 1 17.6 0Z"
      clip-rule="evenodd"
    />
  </svg>
`;
